import { BaseResponseDto } from "./base-response-dto";

export class ResponseDto<T> extends BaseResponseDto<T> {
  public code!: number;
}
